// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2cc3h","obliqueLineWrap":"membershipbadge_obliqueLineWrap__21304","obliqueLine":"membershipbadge_obliqueLine__YOdaI"};